import * as yup from 'yup';

export const validationSchema = yup.object({
    nombreCompleto: yup.string('Debe ingresar un nombre').required('Este campo es obligatorio'),
    email: yup.string('Ingrese un E-mail').email('Ingrese un E-mail valido').nullable(true),
    dni: yup.string('Ingrese un numero de dni').nullable(true).matches(/^[0-9]{7,8}$/gm),
    telefono: yup.string('Ingrese un numero de telefono').nullable(true),
    preferenciaPago: yup.mixed().oneOf(['CREDITO', 'EFECTIVO', 'NINGUNA', 'CONSIGNACION'], 'La preferencia de pago es invalida')
});